<script>
  import { fly, blur } from 'svelte/transition';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  export let idFiche;
</script>

{#if !idFiche}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="0" />
  </div>
{/if}
{#if idFiche == 1}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="{idFiche}" titre="{'Type d’installation'}" />
  </div>
{/if}
{#if idFiche == '1a' || idFiche == '1a' || idFiche == '1b' || idFiche == '1b'}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="2" titre="{'Durée de la résistance au feu'}" />
  </div>
{/if}
{#if idFiche == '1a2a' || idFiche == '1a2a' || idFiche == '1a2b' || idFiche == '1a2c' || idFiche == '1a2d'}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="2" titre="{'Epaisseur de la plaque de plâtre'}" />
  </div>
{/if}

<!-- {#if idFiche == '1b2a' || idFiche == '1b2d' ||  idFiche == '1a2b3'|| idFiche == '1a2c3'|| idFiche == '1a2d34'|| idFiche == '1b2b'|| idFiche == '1b2c'}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="2" titre="{'Dimensions souhaitez'}" />
  </div>
{/if} -->

{#if idFiche == '1b2a' || idFiche == '1b2d'}
  <TitleNNumber idFiche="2" titre="{'Dimensions souhaitez'}" />
{/if}
{#if idFiche == '1a2a3a' || idFiche == '1a2a3b' || idFiche == '1a2b3' || idFiche == '1a2c3'}
  <TitleNNumber idFiche="3" titre="{'Dimensions souhaitez'}" />
{/if}

{#if idFiche == '1b2a3' || idFiche == '1b2d3'}
  <TitleNNumber idFiche="3" titre="{'Côté d’ouverture'}" />
{/if}

{#if idFiche == '1a2a3a4' || idFiche == '1a2a3b4' || idFiche == '1a2b34' || idFiche == '1a2c34'}
  <TitleNNumber idFiche="4" titre="{'Côté d’ouverture'}" />
{/if}

{#if idFiche == '1a2a3a45' || idFiche == '1a2a3b45' || idFiche == '1a2b345' || idFiche == '1a2c345'}
  <TitleNNumber idFiche="5" titre="{'Type de fermeture'}" />
{/if}

{#if idFiche == '1a2d34' || idFiche == '1b2a34' || idFiche == '1b2d34' || idFiche == '1b2b3' || idFiche == '1b2c3'}
  <TitleNNumber idFiche="4" titre="{'Type de fermeture'}" />
{/if}

{#if idFiche == '1b2b' || idFiche == '1b2c'}
  <TitleNNumber idFiche="3" titre="{'Dimensions souhaitez'}" />
{/if}

<!--   
{:else if idFiche == 2}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="{idFiche}" titre="{'Durée de la résistance au feu'}" />
  </div>
{:else if idFiche == 3}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="{idFiche}" titre="{'Epaisseur de la plaque de plâtre'}" />
  </div>
{:else if idFiche == 4}
  <TitleNNumber idFiche="{idFiche}" titre="{'Dimensions souhaitez'}" />
{:else if idFiche == 5}
  <TitleNNumber idFiche="{idFiche}" titre="{'Côté d’ouverture'}" />
{:else if idFiche == 6}
  <TitleNNumber idFiche="{idFiche}" titre="{'Type de fermeture'}" />
{/if} -->
